import { LOCATION_CHANGE } from "connected-react-router";
import { produce } from 'immer';
import _ from "lodash";
import {
    REGISTRATION_START_MOBILE_ACTION
} from "../mobileAppCore/mobileAppConstants";
import {
    CHECK_CODE_FAILURE,
    CHECK_CODE_START,
    CHECK_CODE_SUCCESS,
    CREATE_PASSWORD_FAILURE,
    CREATE_PASSWORD_START,
    CREATE_PASSWORD_SUCCESS,
    LOGIN_FAILURE,
    LOGIN_START,
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    PASSWORD_RESET_FAILURE,
    PASSWORD_RESET_RESET,
    PASSWORD_RESET_START,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_UPDATE_FAILURE,
    PASSWORD_UPDATE_START,
    PASSWORD_UPDATE_SUCCESS,
    REGISTRATION_FAILURE,
    REGISTRATION_START,
    REGISTRATION_SUCCESS,
    SET_CHANGE_EMAIL_SUCCESS,
    SET_REGISTRATION_DATA,
} from "../modules/Login/loginConstants";
import {
    APP_INIT_FAILURE,
    APP_INIT_SUCCESS,
    CLOSE_MODAL,
    COMPLETE_ONBOARDING_FAILURE,
    COMPLETE_ONBOARDING_START,
    COMPLETE_ONBOARDING_SUCCESS,
    LOAD_ACCOUNT_TRADE_INFO_FAILURE,
    LOAD_ACCOUNT_TRADE_INFO_START,
    LOAD_ACCOUNT_TRADE_INFO_SUCCESS,
    OPEN_MODAL,
    RESET_FORM_ERROR,
    SET_IS_FIRST_LOGIN,
    SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE,
    SET_IS_OPEN_RESPAWN_BANNER_VISIBLE,
    SET_USER_SELECTED_ACCOUNT_CODE,
    UPDATE_AB_TEST_IS_USED_SUCCESS,
    USER_UPDATE_PASSWORD_FAILURE,
    USER_UPDATE_PASSWORD_START,
    USER_UPDATE_SUCCESS
} from "./appConstants";

const initialState = {
    inited: false,
    lang: null,
    locale: null,
    visibility: true,

    loggedIn: false,
    loggedInProcess: false,

    formError: '',
    passwordResetSent: false,
    user: {},
    openedModal: null,
    openedModalPrevious: null,

    availableCountries: [],
    availableLocales: [],
    appKeys: {},

    registration: null,
    changeEmail: false,
    codeChecked: false,
    isCheckCodeLoading: false,

    abTests: {},

    isCreatePasswordLoading: false,
    isFirstLogin: false,

    features: {},
    partner: {},

    onboardingCompleted: false,
    onboardingCompleteLoading: false,
    accountsTradeInfo: {},

    selectedAccountCode: null,
    padVersion: null,

    isOpenMobileAppBannerVisible: true,

    isOpenRespawnBannerVisible: false,
};

const appReducer = (state = initialState, action) =>
    produce(state, (draft) => {
        switch (action.type) {

            case APP_INIT_SUCCESS:
                draft.availableCountries = action.payload.availableCountries || [];
                draft.availableLocales = action.payload.availableLocales || [];
                draft.appKeys = action.payload.appKeys;

                draft.inited = true;
                draft.lang = action.payload.lang;
                draft.locale = action.payload.locale;

                draft.loggedIn = !!action.payload.loggedIn;
                draft.user = action.payload.user || {};
                draft.passwordMinLength = action.payload.passwordMinLength;
                draft.abTests = action.payload.abTests;
                draft.onboardingCompleted = action.payload.onboardingCompleted;
                draft.features = action.payload.features || {};
                draft.padVersion = action.payload.v;
                break;

            case APP_INIT_FAILURE:
                draft.inited = true;
                break;

            case LOGIN_START:
                draft.formError = '';
                draft.loggedInProcess = true;
                break;

            case LOGIN_SUCCESS:
                draft.loggedIn = true;
                draft.loggedInProcess = false;
                break;

            case LOGIN_FAILURE:
                draft.formError = action.payload;
                draft.loggedInProcess = false;
                break;

            case REGISTRATION_START:
            case REGISTRATION_START_MOBILE_ACTION:
                draft.formError = '';
                draft.loggedInProcess = true;
                break;

            case REGISTRATION_SUCCESS:
                draft.registration = action.payload;
                draft.codeChecked = false;
                draft.loggedInProcess = false;
                break;

            case SET_REGISTRATION_DATA:
                draft.registration = action.payload;
                break;

            case REGISTRATION_FAILURE:
                draft.formError = action.payload;
                draft.changeEmail = true;
                draft.loggedInProcess = false;
                break;

            case PASSWORD_RESET_START:
                draft.formError = '';
                break;

            case PASSWORD_RESET_SUCCESS:
                draft.passwordResetSent = true;
                break;

            case PASSWORD_RESET_FAILURE:
                draft.passwordResetSent = false;
                draft.formError = action.payload;
                break;

            case PASSWORD_RESET_RESET:
                draft.passwordResetSent = false;
                break;

            case PASSWORD_UPDATE_START:
                draft.formError = '';
                break;

            case PASSWORD_UPDATE_SUCCESS:
                draft.loggedIn = true;
                break;

            case PASSWORD_UPDATE_FAILURE:
                draft.formError = action.payload;
                break;

            case SET_CHANGE_EMAIL_SUCCESS:
                draft.changeEmail = action.payload;
                break;

            case CHECK_CODE_START:
                draft.formError = null;
                draft.isCheckCodeLoading = true;
                break;

            case CHECK_CODE_SUCCESS:
                draft.codeChecked = true;
                draft.isCheckCodeLoading = false;
                break;

            case CHECK_CODE_FAILURE:
                draft.formError = action.payload;
                draft.isCheckCodeLoading = false;
                break;

            case CREATE_PASSWORD_START:
                draft.codeChecked = true;
                draft.formError = null;
                draft.isCreatePasswordLoading = true;
                break;

            case CREATE_PASSWORD_SUCCESS:
                draft.loggedIn = true;
                draft.isCreatePasswordLoading = false;
                break;

            case CREATE_PASSWORD_FAILURE:
                draft.formError = action.payload;
                draft.isCreatePasswordLoading = false;
                break;

            case USER_UPDATE_SUCCESS:
                draft.user = { ...draft.user, ...(action.payload || {}) };
                break;

            case USER_UPDATE_PASSWORD_START:
                draft.formError = null;
                break;

            case USER_UPDATE_PASSWORD_FAILURE:
                draft.formError = action.payload;
                break;

            case OPEN_MODAL:
                if (_.isObject(action.payload)) {
                    draft.openedModal = action.payload;
                } else {
                    draft.openedModal = {
                        name: action.payload
                    };
                }
                break;

            case CLOSE_MODAL:
                draft.openedModalPrevious = Object.assign({}, draft.openedModal);
                draft.openedModal = null;
                break;

            case LOCATION_CHANGE:
                draft.formError = '';
                break;

            case LOGOUT_SUCCESS:
                return {
                    ...initialState,
                    inited: true,
                    lang: state.lang,
                    locale: state.locale,
                    availableLocales: state.availableLocales,
                    availableCountries: state.availableCountries,
                    appKeys: state.appKeys,
                    abTests: state.abTests,
                    features: state.features,
                };

            case SET_IS_FIRST_LOGIN:
                draft.isFirstLogin = action.payload;
                break;

            case COMPLETE_ONBOARDING_START:
                draft.onboardingCompleteLoading = true;
                break;
            case COMPLETE_ONBOARDING_SUCCESS:
                draft.onboardingCompleteLoading = false;
                draft.onboardingCompleted = true;
                break;
            case COMPLETE_ONBOARDING_FAILURE:
                draft.onboardingCompleteLoading = false;
                break;

            case RESET_FORM_ERROR:
                draft.formError = '';
                break;

            case UPDATE_AB_TEST_IS_USED_SUCCESS:
                const testName = action.payload.test_name;
                if (draft.abTests[testName]) {
                    draft.abTests[testName].isUsed = true;
                }
                break;
            case LOAD_ACCOUNT_TRADE_INFO_START:
                if (!draft.accountsTradeInfo[action.payload]) draft.accountsTradeInfo[action.payload] = {};
                draft.accountsTradeInfo[action.payload].isLoading = true;
                break;
            case LOAD_ACCOUNT_TRADE_INFO_SUCCESS:
                draft.accountsTradeInfo[action.payload.accountCode].isLoading = false;
                draft.accountsTradeInfo[action.payload.accountCode].data = action.payload.data;
                break;
            case LOAD_ACCOUNT_TRADE_INFO_FAILURE:
                draft.accountsTradeInfo[action.payload.accountCode].isLoading = false;
                break;

            case SET_USER_SELECTED_ACCOUNT_CODE:
                draft.selectedAccountCode = action.payload;
                break;

            case SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE:
                draft.isOpenMobileAppBannerVisible = action.payload;
                break;

            case SET_IS_OPEN_RESPAWN_BANNER_VISIBLE:
                draft.isOpenRespawnBannerVisible = action.payload;
                break;

            case 'VISIBILITY_CHANGE':
                draft.visibility = !document.hidden;
                break;

            default:
                return state;
        }
    });

export default appReducer;
